import { authGetAll } from '../../http';

export const getPromoPriveSSORedirectUrl = async () => {
  return await authGetAll('api/v1/integrations/promoprive/sso/redirect');
};